import { IconButton, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { playgroundClassNames as classNames } from "../../../Styles";
import { ResultsPanelProps } from "../../../Interfaces/PromptPlayground.interfaces";
import { ErrorDisplay } from "../../Common";

export const ResultsPanel: React.FC<ResultsPanelProps> = ({
  isExecuting,
  isQueryExecutionError,
  markdownRef,
  onCopy,
  resultImages,
  results
}) => {
  return (
    <div className={classNames.rightContainerStyle}>
      <IconButton
        iconProps={{ iconName: "Copy" }}
        className={classNames.copyIconStyle}
        onClick={() => onCopy(markdownRef.current?.innerHTML ?? "")}
        style={{ margin: 0, position: "absolute", right: 34, top: 24 }}
      />
      <div className={classNames.resultsContainerStyle}>
        {isExecuting ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Spinner size={SpinnerSize.large} label="Generating results..." />
          </div>
        ) : (
          <div ref={markdownRef}>
            {isQueryExecutionError && results ? (
              <ErrorDisplay errorMessage={results} />
            ) : (
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {results || "Results will be displayed here..."}
              </ReactMarkdown>
            )}
            {resultImages && resultImages.length > 0 && (
              <div style={{ marginTop: "20px" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {resultImages.map((image, index) => (
                    <div
                      key={`image-${image.substring(0, 20)}-${index}`}
                      style={{ maxWidth: "100%", marginBottom: "10px" }}
                    >
                      <img
                        src={`data:image/png;base64,${image}`}
                        alt={`Generated content ${index + 1}`}
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
